export default __webpack_public_path__ + "static/media/meeting.90ae133e.jpg";